import React, { PureComponent } from 'react';

import {
  Avatar,
  Item,
  Card,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Button,
} from 'components';
import StarIcon from 'material-ui-icons/Star';
import ShareIcon from 'material-ui-icons/Share';
import RemoveRedEyeIcon from 'material-ui-icons/RemoveRedEye';

class ToolViewGithubInfo extends PureComponent {
  state = {
    starCount: null,
    forksCount: null,
    watchCount: null,
  };

  isGithubSource = sourceUrl => {
    return sourceUrl && sourceUrl.indexOf('github.com') > -1;
  };

  getResourcePath = sourceUrl => {
    return this.isGithubSource(sourceUrl) && sourceUrl.split('github.com/')[1];
  };

  fetchGithubData = async sourceUrl => {
    if (this.getResourcePath(sourceUrl)) {
      try {
        const response = await fetch(
          'https://api.github.com/repos/' + this.getResourcePath(sourceUrl)
        );

        const data = (await response.json()) || {};
        const { stargazers_count, watchers_count, forks_count } = data;

        this.setState({
          starCount: stargazers_count,
          watchCount: watchers_count,
          forksCount: forks_count,
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  componentWillReceiveProps({ isOpenSource, sourceUrl }) {
    if (
      isOpenSource &&
      sourceUrl &&
      this.isGithubSource(sourceUrl)
      // sourceUrl !== this.props.sourceUrl
    ) {
      this.fetchGithubData(sourceUrl);
    }
  }

  render() {
    const { isOpenSource, sourceUrl } = this.props;

    if (!isOpenSource || !this.isGithubSource(sourceUrl)) {
      return null;
    }

    return (
      <Item>
        <Card>
          <CardHeader
            title={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <span>Github</span>
                <Button
                  color="accent"
                  href={sourceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  소스 보기
                </Button>
              </div>
            }
          />
          <List>
            <ListItem button>
              <Avatar>
                <StarIcon />
              </Avatar>
              <ListItemText primary={this.state.starCount} secondary="Stars" />
            </ListItem>
            <ListItem button>
              <Avatar>
                <ShareIcon />
              </Avatar>
              <ListItemText primary={this.state.forksCount} secondary="Forks" />
            </ListItem>
            <ListItem button>
              <Avatar>
                <RemoveRedEyeIcon />
              </Avatar>
              <ListItemText primary={this.state.watchCount} secondary="Watch" />
            </ListItem>
          </List>
        </Card>
      </Item>
    );
  }
}

export default ToolViewGithubInfo;



// WEBPACK FOOTER //
// ./src/App/Tool/components/ToolViewGithubInfo.js